import { CloseCircle, Tag } from "iconsax-react-nativejs";
import { Pressable, Text, View } from "react-native";
import { useTheme } from "react-native-paper";

type TagPillProps = Readonly<{
  tag: string;
  onRemove: (tag: string) => void;
  isEditing: boolean;
}>;

const TagPill = ({ tag, onRemove, isEditing }: TagPillProps) => {
  return (
    <View
      className="flex-row items-center gap-1 rounded-full"
    >
      <Text className="text-sm italic text-primary hover:underline decoration-1">
        {'#'+tag}
      </Text>
      {isEditing && (
        <Pressable onPress={() => onRemove(tag)} hitSlop={8} className="rounded-full hover:bg-ash-3">
          {({ hovered }) => (
            <CloseCircle
              size={20}
              color={hovered ? "var(--color-primary-default)" : "var(--color-ash-1)"}
            />
          )}
        </Pressable>
      )}
    </View>
  );
};

export default TagPill;
